import { memo, useState, useEffect } from 'react';

const COLORS_LIST = [
  { name: 'Gold', hex: '#C9A84C' }, { name: 'Rose', hex: '#C4A095' },
  { name: 'Sage', hex: '#7A8B6F' }, { name: 'Navy', hex: '#1A1A2E' },
  { name: 'Blush', hex: '#E8A0BF' }, { name: 'Amber', hex: '#D4A574' },
];

const ColorMatchGame = memo(() => {
  const [score, setScore] = useState(0);
  const [round, setRound] = useState(0);
  const [wrong, setWrong] = useState(false);
  const [currentColor, setCurrentColor] = useState(null);
  const [displayColor, setDisplayColor] = useState(null);

  const newRound = () => {
    const word = COLORS_LIST[Math.floor(Math.random() * COLORS_LIST.length)];
    let ink;
    do { ink = COLORS_LIST[Math.floor(Math.random() * COLORS_LIST.length)]; } while (ink.name === word.name);
    setCurrentColor(word);
    setDisplayColor(ink);
    setWrong(false);
    setRound(r => r + 1);
  };

  useEffect(() => { newRound(); }, []);

  const handlePick = (colorName) => {
    if (colorName === currentColor?.name) {
      setScore(s => s + 1);
      newRound();
    } else {
      setWrong(true);
      setTimeout(() => newRound(), 500);
    }
  };

  return (
    <div className="text-center">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-sans font-medium" style={{ color: 'inherit' }}>Color Match</span>
        <span className="text-xs font-sans" style={{ color: '#8c8782' }}>Score: {score}/{round}</span>
      </div>
      <p className="text-xs font-sans mb-3" style={{ color: '#8c8782' }}>
        Tap the color that matches the <strong>word</strong>, not the ink!
      </p>
      {currentColor && displayColor && (
        <p className="font-serif text-3xl font-bold mb-4" style={{ color: wrong ? '#c47272' : displayColor.hex }}>
          {currentColor.name}
        </p>
      )}
      <div className="grid grid-cols-3 gap-2">
        {COLORS_LIST.map(c => (
          <button
            key={c.name}
            onClick={() => handlePick(c.name)}
            className="py-2 rounded-lg text-xs font-sans font-medium transition-all hover:scale-105"
            style={{ background: c.hex, color: '#fff', border: 'none', cursor: 'pointer', textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}
          >
            {c.name}
          </button>
        ))}
      </div>
    </div>
  );
});

ColorMatchGame.displayName = 'ColorMatchGame';
export default ColorMatchGame;
